import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/tailwind.css";
import "devextreme/dist/css/dx.light.css";
import VueSweetalert2 from "vue-sweetalert2";
import themes from "devextreme/ui/themes";
//import "./themes/generated/theme.base.css";
import "./themes/generated/theme.additional.css";
import { BootstrapVue } from "bootstrap/dist/js/bootstrap.js";
import "bootstrap/dist/css/bootstrap.min.css";
// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";
import "vue-select/dist/vue-select.css"


import { loadMessages, locale } from 'devextreme/localization'
import "./components/css/dimensions.css";

// تحميل اللغة العربية
loadMessages({
  ar: {
    'dxDataGrid-editingDeleteRow': 'إلغاء التعديل',
    'dxDataGrid-editingConfirmDeleteMessage': 'هل أنت متأكد أنك تريد إالغاء التعديل ؟',
    'dxDataGrid-editingConfirmDeleteTitle': 'تأكيد إالغاء التعديل',
  }
});

// تعيين اللغة
locale('ar');


themes.initialized(() => {
  createApp(App)
    .use(router)
    .use(BootstrapVue)
    .use(VueSweetalert2)
    .mount("#app");
});



